import React from 'react';
import _ from 'lodash';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    borderRadius: '5px !important'
  }
});
const SelectedFiltersForPopUpFilters = ({ object, dispalyName, onCancel }) => {
  const classes = useStyles();
  return (
    <div className="w-auto flex flex-wrap  ">
      {Object.keys(object || {})?.map(each => (
        <Chip
          className={classes.root}
          label={_.get(object, `${each}.${dispalyName}`)}
          onDelete={e => {
            delete object[each];
            onCancel({
              ...(object || {})
            });
          }}
          color="primary"
          style={{ marginLeft: '2px', marginTop: '5px' }}
        />
      ))}
    </div>
  );
};
export default SelectedFiltersForPopUpFilters;
